'use client';

import React__default, { useContext } from 'react';
import '../../Utils/constants.js';

var TranslateContext = React__default.createContext({
    t: function () { return ''; }
});
var useTranslate = function () { return useContext(TranslateContext); };

export { TranslateContext, useTranslate };
//# sourceMappingURL=index.js.map
